import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center px-6 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20minimalist%20technology%20background%20with%20geometric%20patterns%20soft%20gradients%20and%20modern%20digital%20aesthetic%20in%20dark%20tones%20with%20subtle%20blue%20accents%20professional%20tech%20workspace%20atmosphere&width=1920&height=1080&seq=herobg1&orientation=landscape"
          alt="Background"
          loading="lazy"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto w-full grid lg:grid-cols-2 gap-12 items-center">
        {/* Left: Text Content */}
        <div className="text-white">
          <h1 className="text-[47px] font-black mb-6 leading-tight">
            Cherif Ibrahima<br />
            <span className="text-[#0066FF]">Aïdara Sadio</span>
          </h1>

          <div className="text-2xl font-light mb-8 text-gray-200">
            {t('hero.title')} | Ingénieur Logiciel | Concepteur UX/UI
          </div>

          <div className="flex items-center gap-4 mb-8 text-gray-300">
            <div className="flex items-center gap-2">
              <i className="ri-map-pin-line text-[#0066FF]"></i>
              <span>Dakar, Sénégal</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-briefcase-line text-[#0066FF]"></i>
              <span>3 ans d'expérience</span>
            </div>
          </div>

          <p className="text-lg leading-relaxed mb-10 text-gray-200 max-w-2xl">
            {t('hero.description')}
          </p>

          <div className="flex flex-wrap gap-4">
            <a
              href="#contact"
              className="bg-[#0066FF] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#0052CC] transition-all duration-300 cursor-pointer inline-flex items-center gap-2 whitespace-nowrap shadow-lg hover:shadow-xl hover:-translate-y-1"
            >
              <i className="ri-mail-line"></i>
              {t('hero.contact')}
            </a>
            <a
              href="#projects"
              className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full font-semibold hover:bg-white/20 transition-all duration-300 cursor-pointer inline-flex items-center gap-2 whitespace-nowrap border border-white/20"
            >
              <i className="ri-folder-line"></i>
              {t('hero.cta')}
            </a>
          </div>

          <div className="flex gap-4 mt-10">
            <a
              href="https://github.com/brahim1205"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full hover:bg-[#0066FF] transition-all duration-300 cursor-pointer border border-white/20 hover:border-[#0066FF]"
            >
              <i className="ri-github-fill text-xl text-white"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/ch%C3%A9rif-ibrahima-aidara-sadio-5ba9a8256/?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BQ0EJBWYmRPuY469VEdaF5w%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full hover:bg-[#0066FF] transition-all duration-300 cursor-pointer border border-white/20 hover:border-[#0066FF]"
            >
              <i className="ri-linkedin-fill text-xl text-white"></i>
            </a>
            <a
              href="mailto:sadiocherif11@gmail.com"
              className="w-12 h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full hover:bg-[#0066FF] transition-all duration-300 cursor-pointer border border-white/20 hover:border-[#0066FF]"
            >
              <i className="ri-mail-line text-xl text-white"></i>
            </a>
            <a
              href="tel:+221766178284"
              className="w-12 h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full hover:bg-[#0066FF] transition-all duration-300 cursor-pointer border border-white/20 hover:border-[#0066FF]"
            >
              <i className="ri-phone-line text-xl text-white"></i>
            </a>
          </div>
        </div>

        {/* Right: Profile Image */}
        <div className="flex justify-center lg:justify-end">
          <div className="relative">
            <div className="absolute inset-0 bg-[#0066FF] rounded-3xl blur-3xl opacity-30 animate-pulse"></div>
            <div className="relative w-full h-full max-w-md">
              <img
                src="https://static.readdy.ai/image/c21dcdc26ecafc1fbc46806db6089fae/7d4ef6e928f286311fb143e3834faf20.jpeg"
                alt="Cherif Ibrahima Aïdara Sadio"
                className="w-full h-full object-cover rounded-3xl shadow-2xl border-4 border-white/10"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10">
        <a href="#about" className="cursor-pointer">
          <i className="ri-arrow-drop-down-line text-4xl text-white/70 animate-scroll-bounce"></i>
        </a>
      </div>
    </section>
  );
}
